import { mapActions, mapState } from 'vuex';
import ContentContextMixin from '@/mixins/content-context.js';

import StudentModeHelper from '@/helpers/studentMode';
import { TemplateName } from '@/helpers/templateType';
import academicMainTypeHelper from '@/helpers/academicMainType';

export default {
  mixins   : [ContentContextMixin],
  computed : {
    ...mapState({
      username      : state => state._core.user.name,
      userId        : state => state._core.user.id,
      isStudentMode : state => state.plataforma.user.isStudentMode,
      userRole      : state => state._core.auth.currentRole.role.alias
    })
  },
  methods: {
    ...mapActions({
      actionAccessStudentMode: 'plataforma/courses/actionAccessStudentMode'
    }),
    accessStudentMode(academicMainId) {
      const academicMainType = this.context ? academicMainTypeHelper.getName(this.context.academicMainTypeId) : this.$route.params.id;
      this.$dialog.show({
        type    : 'info',
        title   : this.$t('course.studentMode.studentView'),
        message : this.$t(`course.studentMode.confirmationModal.message.${academicMainType}`, { username: this.username }),
        dark    : this.context && this.context.templateName === TemplateName.STREAMING,
        buttons : [
          {
            variant : 'text',
            text    : this.$t('common.cancel'),
            icon    : null,
            color   : null,
            action  : () => {
              this.$dialog.hide();
            }
          },
          {
            variant     : 'default',
            text        : this.$t('common.continue'),
            icon        : null,
            color       : null,
            useLoading  : true,
            useDisabled : true,
            action      : async () => {
              this.$dialog.hide();

              try {
                this.$nuxt.$loading.start();
                const originUserToken = this.$token.get();
                const { user, referenceUser } = await this.actionAccessStudentMode({ academicMainId });

                StudentModeHelper.saveStudentMode({
                  originPath  : this.$route.path,
                  previewUser : {
                    id        : user.safeaUserId,
                    name      : user.name,
                    token     : user.token,
                    isPreview : user.isPreview
                  },
                  originUser: {
                    token      : originUserToken,
                    id         : referenceUser.safeaUserId,
                    originRole : this.userRole
                  },
                  academicMainId,
                  academicMainType
                });
              } catch (error) {
                if (error.code === 'plataforma-v1-user-409_user-being-deleted') {
                  this.$dialog.hide();

                  this.$dialog.show({
                    type                 : 'warning',
                    title                : this.$t('common.attentionExclamation'),
                    message              : this.$t('course.studentMode.deleteProcessModalMessage'),
                    showCancelButton     : false,
                    confirmButtonVariant : 'text'
                  });
                } else {
                  this.$toast.error(error);
                }
              } finally {
                this.$nuxt.$loading.finish();
              }
            }
          }
        ]
      });
    }
  }
};
